import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { fpds as x } from "@ucl/shared-component-foundations";
import { c } from "./index-8b07dec9.js";
import { useState as T, Children as h, cloneElement as k } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as q } from "./getMetrics-953aa4f8.js";
import { a as z } from "./index-5d0f31c6.js";
import { B as D, S as E, a as O } from "./showMoreLess.styles-679d33f9.js";
import { jsx as t, jsxs as w, Fragment as u } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "styled-components";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
var Yr = function(o) {
  var d = o.alignment, i = d === void 0 ? "left" : d, m = o.className, s = o.children, p = o.previewContent, M = o.showMoreLessText, f = M === void 0 ? {
    showMore: "Show More",
    showLess: "Show Less"
  } : M, a = o.disabled, b = q({
    label: "ShowMoreLess"
  }), S = T(!1), e = S[0], y = S[1], N = function() {
    y(!e);
  }, I = function() {
    var l = e ? "caretUpFilled" : "caretDownFilled";
    return /* @__PURE__ */ t(z, {
      icon: l,
      "aria-label": "caret-up",
      height: "20px",
      width: "20px",
      color: x.semantic.color.icon.primary,
      className: "show-more-icon"
    });
  }, v = function() {
    return /* @__PURE__ */ w(u, {
      children: [i === "inline" && /* @__PURE__ */ t("span", {
        style: {
          padding: "0 " + x.semantic.space["2x"]
        }
      }), /* @__PURE__ */ t(E, {
        onClick: N,
        className: c(["ShowMoreLessWrapper", m, "ShowMoreLessWrapper--" + i, {
          "ShowMoreLessWrapper--disabled": a
        }]),
        tabIndex: 0,
        "aria-label": "show-more-less",
        children: /* @__PURE__ */ t(O, {
          size: "medium",
          variant: "tertiary",
          rightIcon: I(),
          disabled: a,
          className: c(["ShowMoreLessContainer", m, {
            "ShowMoreLessContainer--disabled": a
          }]),
          children: e ? f.showLess : f.showMore
        })
      })]
    });
  }, B = function() {
    var l = h.map(e ? s : p, function(r, j) {
      var F = e ? h.count(s) : h.count(p);
      if (j === F - 1) {
        var g, C, L = /* @__PURE__ */ w(u, {
          children: [typeof r == "string" || !(r != null && (g = r.props) != null && g.children) ? r : r.props.children, v()]
        });
        return typeof r == "string" || !(r != null && (C = r.props) != null && C.children) ? L : /* @__PURE__ */ k(r, {
          children: L
        });
      } else
        return r;
    });
    return l;
  }, W = function() {
    return /* @__PURE__ */ w(u, {
      children: [e ? s : p, v()]
    });
  };
  return /* @__PURE__ */ t(D, Object.assign({
    className: c(["BodyContentContainer", m, "BodyContentContainer--" + i])
  }, b, {
    children: i === "inline" ? B() : W()
  }));
};
export {
  Yr as ShowMoreLess
};
